import { SUPPORTED_LANGUAGES } from '@constants/languages';
import i18n from 'i18next';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { getDefaultLanguage, getLangNamespace } from './utils';
import { version as v } from '../../package.json';

const ns = getLangNamespace();

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    fallbackLng: getDefaultLanguage().code,
    supportedLngs: SUPPORTED_LANGUAGES.map((lng) => lng.code),
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      queryStringParams: { v },
    },
    react: {
      useSuspense: true,
    },
    ns: [ns],
    defaultNS: ns,
  });

export default i18n;
